// Lire une animation PUBLIÉE (servie par `get_animation`, migration 0666).
//
// Le serveur l'a validée à la publication (`animation-publish`, bundle) : le
// lecteur n'a qu'à la mettre au format courant et en vérifier la forme
// (schéma Zod), sans refaire les contrôles de cohérence, de mise en page ni
// de rythme. Deux refus possibles, distingués pour l'affichage :
//   - `update` : version du lecteur ou du format trop récente pour cette app
//     (« Mets à jour l'application ») ;
//   - `invalid` : document illisible (ne devrait jamais arriver).

import { migrateJraf } from './migrate';
import { canPlay } from './runtime';
import { jrafDocumentSchema, type JrafDocument } from './schema/document';

export type PublishedRead =
  | { ok: true; doc: JrafDocument }
  | { ok: false; reason: 'update' | 'invalid'; message: string };

export function readPublishedJraf(raw: unknown, runtimeMin: number): PublishedRead {
  if (!Number.isInteger(runtimeMin) || runtimeMin < 1) {
    return { ok: false, reason: 'invalid', message: 'Version du lecteur exigée invalide.' };
  }
  if (!canPlay(runtimeMin)) {
    return {
      ok: false,
      reason: 'update',
      message: `Cette animation demande une version plus récente du lecteur (${runtimeMin}).`,
    };
  }
  const migrated = migrateJraf(raw);
  if (!migrated.ok) {
    return {
      ok: false,
      reason: migrated.code === 'too_new' ? 'update' : 'invalid',
      message: migrated.message,
    };
  }
  const parsed = jrafDocumentSchema.safeParse(migrated.doc);
  if (!parsed.success) {
    return { ok: false, reason: 'invalid', message: 'Animation illisible.' };
  }
  return { ok: true, doc: parsed.data };
}
